import { get } from '../../index'
import base from '../../base.js'

export const getWorkbench = (params) => get(base.workbench, params)
